module.exports = __webpack_public_path__ + "static/img/celue.9da95a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/celue.png
// module id = 6j7E
// module chunks = 5